var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": "Select & Fill Client Code Info",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "append-to-body": "",
      "width": "700px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "autocomplete": "off",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_vm.showItems.includes('companyName') ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company Name",
      "prop": "companyName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.companyName,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "companyName", $$v);
      },
      expression: "dataForm.companyName"
    }
  })], 1)], 1) : _vm._e(), _vm.showItems.includes('uen') ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "UEN",
      "prop": "uen"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.uen,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "uen", $$v);
      },
      expression: "dataForm.uen"
    }
  })], 1)], 1) : _vm._e(), _vm.showItems.includes('billingAddresses') ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Billing Addresses",
      "prop": "billingInfoIndex"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: _vm.dataForm.billingInfoIndex,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "billingInfoIndex", $$v);
      },
      expression: "dataForm.billingInfoIndex"
    }
  }, _vm._l(_vm.billingInfoList, function (item, index) {
    return _c('el-option', {
      key: "billing addresses-".concat(index),
      attrs: {
        "label": "".concat(item.billingAddress || null, " / ").concat(item.billingCountry || null, " / ").concat(item.billingPostalCode || null),
        "value": index
      }
    });
  }), 1)], 1)], 1) : _vm._e()], 1)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "medium"
    },
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }